import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useSettings } from '../../contexts/SettingsContext';

const SimpleDailyDuaCard = ({ duas, currentDuaIndex, onDuaChange, render }) => {
  const currentDua = duas?.[currentDuaIndex];
  
  const handleNext = () => {
    onDuaChange((currentDuaIndex + 1) % duas.length);
  };

  const handlePrevious = () => {
    onDuaChange((currentDuaIndex - 1 + duas.length) % duas.length);
  };
  
  return render({
    arabic: currentDua?.arabic,
    translation: currentDua?.translation,
    reference: currentDua?.reference,
    onNext: handleNext,
    onPrevious: handlePrevious,
    navigationButtons: (
      <div className="flex gap-2">
        <button 
          onClick={handlePrevious}
          className="flex items-center gap-1 text-sm px-3 py-1.5 rounded-full bg-white/10 hover:bg-white/20 transition-colors"
        >
          <ChevronLeft className="w-4 h-4" />
          Previous
        </button>
        <button 
          onClick={handleNext}
          className="flex items-center gap-1 text-sm px-3 py-1.5 rounded-full bg-white/10 hover:bg-white/20 transition-colors"
        >
          Next
          <ChevronRight className="w-4 h-4" />
        </button>
      </div>
    )
  });
};

export default SimpleDailyDuaCard;
